import React, { useEffect, useState } from "react";
import {
  DialogContent,
  DialogContentText,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import CustomButton from "../../../../components/common/button/CustomButton";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import useStyles from "../../../../components/common/model/styles";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getSingleLeadFeedbackAction } from "../../../../store/reducers/feedbackSlice";

interface ManageViewFeedbackProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectLead?: any; // Adjust type as per your requirement
  action?: any;
}

const ManageViewFeedback: React.FC<ManageViewFeedbackProps> = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { singleLeadFeedback } = useSelector((state: any) => state.feedback);

  const [fullWidth, setFullWidth] = useState(true);
  const [maxWidth, setMaxWidth] = useState<
    "sm" | "xs" | "md" | "lg" | "xl" | false
  >("lg"); // Adjust the type definition

  const { open, title } = props;

  const closeModel = () => {
    props.onHide();
  };

  const hideHandler = () => {
    props.onHide();
  };

  useEffect(() => {
    if (leadDetails) {
      dispatch(getSingleLeadFeedbackAction(leadDetails?.lead?.generated_id));
    }
  }, [leadDetails]);

  return (
    <>
      <Popup
        open={open} // Example value, replace with your actual state or variable
        title={title} // Example title, replace with your actual title
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton
              style={{ padding: "10px 30px", height: "36px" }}
              variant="outlined"
              title="Cancel"
              onClick={closeModel}
            />
          </>
        }
      >
        <DialogContent>
          <DialogContentText className={classes.formAddBox}>
            <>
              {/* <Grid
                container
                sx={{
                  marginTop: 2,
                  paddingTop: 2,
                }}
              >
                <Grid md={6}></Grid>
                <Grid
                  md={6}
                  sx={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Highly Unsatisfied
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Unsatisfied
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Neither Satisfied <br /> nor Unsatisfied
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                    Satisfied
                  </Typography>
                  <Typography sx={{ fontWeight: 600, fontSize: "14px" }}>
                    High Satisfied
                  </Typography>
                </Grid>
              </Grid>
              <Grid
                container
                sx={{
                  borderTop: "2px solid #F0EFF0",
                  paddingTop: 3,
                  marginTop: 2,
                  paddingBottom: 2,
                }}
              >
                {singleLeadFeedback &&
                  singleLeadFeedback.map((item: any, i: number) => (
                    <Grid key={i} item md={12} sx={{ display: "flex" }}>
                      <Grid md={6}>
                        <Typography sx={{ fontWeight: 600, fontSize: "18px" }}>
                          {item?.question_text}
                        </Typography>
                      </Grid>
                      <Grid
                        md={6}
                        sx={{ display: "flex", justifyContent: "space-around" }}
                      >
                        {item?.category !== "suggestion" ? (
                          <RadioGroup
                            row
                            value={item?.rating || ""}
                            //   onChange={(e) => handleStatusChange(type, e.target.value)}
                            sx={{ display: "contents" }}
                          >
                            {[1, 2, 3, 4, 5].map((status) => (
                              <FormControlLabel
                                key={status}
                                value={status}
                                //   disabled={isDisabled || (status === 'fixed' && isCheck)}
                                sx={{
                                  fontSize: "12px",
                                  marginBottom: "4px",
                                  ".MuiTypography-root": {
                                    fontSize: "12px",
                                  },
                                }}
                                control={
                                  <Radio
                                    disabled
                                    checked={item?.rating === status}
                                    size="small"
                                    sx={{
                                      //   color: error?.[type]?.status ? "red" : "",
                                      transform: "scale(0.8)",
                                      "& .MuiSvgIcon-root": { fontSize: 18 },
                                    }}
                                  />
                                }
                                label={""}
                              />
                            ))}
                          </RadioGroup>
                        ) : (
                          <TextField
                            disabled
                            fullWidth
                            name="comment"
                            label=""
                            value={item.comment}
                            variant="outlined"
                            sx={{ marginTop: "0px !important" }}
                            multiline
                            rows={3}
                            InputProps={{
                              sx: {
                                padding: "8px",
                              },
                            }}
                            // disabled={isDisabled}
                            // error={!!(error && error.comments )}
                            // onChange={(event) => {
                            //   setFormData({ ...formData, comments: event.target.value });
                            // }}
                          />
                        )}
                      </Grid>
                    </Grid>
                  ))}
              </Grid> */}

              {/* new ui */}
                {/* Title */}
    <Grid
      container
      sx={{
        border: "1px solid #9e9e9e",
        background: "#e5f4f1",
        textAlign: "center",
        fontWeight: 600,
        padding: "6px",
        fontSize: "16px",
      }}
    >
      Questionnaire
    </Grid>

    {/* Header */}
    <Grid container sx={{ border: "1px solid #9e9e9e" }}>
      <Grid
        item
        md={7}
        sx={{ borderRight: "1px solid #9e9e9e", padding: "6px", fontWeight: 600 }}
      >
        Question
      </Grid>

      <Grid
        item
        md={3}
        sx={{
          borderRight: "1px solid #9e9e9e",
          padding: "6px",
          fontWeight: 600,
          textAlign: "center",
        }}
      >
        Rating
      </Grid>

      <Grid item md={2} sx={{ padding: "6px", fontWeight: 600 }}>
        How obtained
      </Grid>
    </Grid>

    {/* Questions */}
    {singleLeadFeedback &&
      singleLeadFeedback
        .filter((item: any) => item.category !== "suggestion")
        .map((item: any, i: number) => (
          <Grid container key={i} sx={{ border: "1px solid #9e9e9e" }}>
            
            {/* Question */}
            <Grid
              item
              md={7}
              sx={{ borderRight: "1px solid #9e9e9e", padding: "6px" }}
            >
              {item?.question_text}
            </Grid>

            {/* Rating */}
            <Grid
              item
              md={3}
              sx={{
                borderRight: "1px solid #9e9e9e",
                padding: "6px",
                textAlign: "center",
                letterSpacing: "2px",
              }}
            >
              {"★".repeat(item?.rating || 0)}
            </Grid>

            {/* How obtained */}
            <Grid item md={2} sx={{ padding: "6px" }}>
              {i === 0 ? "Cust Portal" : "Cust Portal"}
            </Grid>

          </Grid>
        ))}

    {/* Suggestion */}
    {singleLeadFeedback &&
      singleLeadFeedback
        .filter((item: any) => item.category === "suggestion")
        .map((item: any, i: number) => (
          <Grid container key={i} sx={{ border: "1px solid #9e9e9e" }}>
            
            <Grid item md={12} sx={{ padding: "6px", fontWeight: 500 }}>
              Is there anything you would like to add
            </Grid>

            <Grid item md={12} sx={{ padding: "6px" }}>
              <TextField
                fullWidth
                disabled
                multiline
                rows={2}
                value={item?.comment || ""}
              />
            </Grid>

          </Grid>
        ))}
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};
export default ManageViewFeedback;
